/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

export function shouldSendAnalyticsEvents(): boolean {
	const { searchParams } = new URL( location.href );
	const internal = searchParams.get( 'internal' );

	// See: #768.
	if ( internal === 'true' || internal === '1' ) {
		return false;
	}

	return true;
}
